export const getSignedSingleUploadContentType = (uploadPlan = {}) =>
  uploadPlan.contentType || "application/octet-stream";

export const validateSingleUploadPlan = (uploadPlan = {}, expectedItem = {}) => {
  if (uploadPlan.strategy !== "single") throw new Error("IMPORT_UPLOAD_PLAN_INVALID: expected single strategy.");
  if (!uploadPlan.uploadUrl) throw new Error("IMPORT_UPLOAD_PLAN_INVALID: upload URL is missing.");
  if (!uploadPlan.itemId || String(uploadPlan.itemId) !== String(expectedItem.id)) {
    throw new Error("IMPORT_UPLOAD_PLAN_INVALID: item ID does not match.");
  }
  if (!uploadPlan.storageKey) throw new Error("IMPORT_UPLOAD_PLAN_INVALID: storage key is missing.");
  if (expectedItem.storageKey && uploadPlan.storageKey !== expectedItem.storageKey) {
    throw new Error("IMPORT_UPLOAD_PLAN_INVALID: storage key does not match.");
  }
  if (!uploadPlan.contentType) throw new Error("IMPORT_UPLOAD_PLAN_INVALID: Content-Type is missing.");
  try {
    const parsed = new URL(uploadPlan.uploadUrl);
    if (!/^https?:$/.test(parsed.protocol) || !parsed.host) throw new Error("invalid URL");
  } catch (_error) {
    throw new Error("IMPORT_UPLOAD_PLAN_INVALID: upload URL is invalid.");
  }
  return uploadPlan;
};

export const runSingleUploadSequence = async ({
  uploadPlan,
  item,
  blob,
  put,
  complete,
  onPutComplete = () => {},
}) => {
  let phase = "initiate";
  try {
    validateSingleUploadPlan(uploadPlan, item);
    if (!blob) throw new Error("IMPORT_SOURCE_FILE_NOT_FOUND: source file is unavailable.");
    if (Number(blob.size) !== Number(item.size)) {
      throw new Error(
        `IMPORT_SOURCE_FILE_MISMATCH: expected ${item.size} bytes but found ${blob.size}.`
      );
    }
    phase = "direct_put";
    await put({ uploadPlan, blob });
    onPutComplete();
    phase = "complete_single";
    await complete();
  } catch (error) {
    error.importFailurePhase = phase;
    throw error;
  }
};

const getStorageTarget = (url = "") => {
  try {
    const parsed = new URL(url);
    return { host: parsed.host, pathname: parsed.pathname };
  } catch (_error) {
    return { host: "unknown", pathname: "unknown" };
  }
};

export const describeDirectStorageUploadError = (error, uploadUrl) => {
  const status = Number(error?.response?.status) || null;
  const hasResponse = Boolean(error?.response);
  const corsOrNetworkFailure = !hasResponse && (
    error?.message === "Network Error" || error?.code === "ERR_NETWORK"
  );

  let userMessage = "The storage upload failed.";
  if (status) userMessage = `The storage server rejected the upload (${status}).`;
  if (corsOrNetworkFailure) {
    userMessage = "The browser could not reach file storage. The storage CORS policy may not allow this site.";
  }

  return {
    userMessage,
    diagnostic: {
      ...getStorageTarget(uploadUrl),
      status,
      statusText: error?.response?.statusText || null,
      response: error?.response?.data || null,
      code: error?.code || null,
      message: error?.message || "Storage upload failed.",
      corsOrNetworkFailure,
    },
  };
};
